import ConfirmationDialog from '../dialogs/confirmationDialog';

interface ExcludeFromRansomwareDialogProps {
  isOpen: boolean;
  triggerExclusion: () => Promise<void>;
  onCancel: () => void;
  resourceName: string;
}

export const ExcludeFromRansomwareDialog = (
  props: ExcludeFromRansomwareDialogProps
) => {
  const { isOpen, triggerExclusion, onCancel, resourceName } = props;
  return (
    <ConfirmationDialog
      isOpen={isOpen}
      title='Exclude resource from ransomware detection'
      description={`Eon will stop monitoring this resource for ransomware, and all current ransomware indicators will be hidden.`}
      onCancel={onCancel}
      onConfirm={triggerExclusion}
      confirmSnackbarText={`Excluded ${resourceName} from ransomware detection.`}
      buttonTitle='Exclude'
    />
  );
};
